<page name="settings.savedCampaign" productBadge="ecf" headerType="h2">
  <p class="tw-text-base">{{ 'settings.savedCampaignDesc' | translate }}</p>
  <app-campaign-list
    [campaigns]="campaigns"
    [params]="params"
    [total]="total"
    [isLoading]="isLoading"
    (getCampaignList)="getSavedCampaigns($event)"
  ></app-campaign-list>
</page>

<ng-container>
  <page name="mysec.watchList" productBadge="pstx" headerType="h2">
    <p class="tw-text-base">{{ 'mysec.watchListDesc' | translate }}</p>
    <app-businesses></app-businesses>
  </page>
</ng-container>
